import React, {useEffect, useState} from "react";
import {PhoneAskDialog} from "../../../../components/dialogs/PhoneAskDialog";
import {NoSmartDriveDialog} from "../../../../components/dialogs/NoSmartDriveDialog";
import {useMtlPackageSelect} from "../hooks/useMtplPackageSelect";
import {strings} from "../../../../strings/strings";
import {RadioGroup, SelectOption} from "../../../../components/inputs/RadioGroup";
import {sumInsuredFormat} from "../../../../utils/format";
import {SimpleTooltip} from "../../../../components/SimpleTooltip";
import {OutputLink} from "../../../../components/OutputLink";
import {EmptySalesPackage} from "../../../../components/SalesPackage/EmptySalesPackage";
import {SalesPackageOption} from "../../../../components/SalesPackage/SalesPackageOption";
import {findVehicleGroup} from "../../../../model/vehicle";
import {StepControls} from "../../../../components/Scenario/Step/StepControls";
import {ReactSVG} from "react-svg";
import discount_icon from "../../../../images/discount_icon.svg";
import "./MtplPackageSelectFormSmartDrive.scss";
import {CascoSmartDrivePackage} from "./CascoSmartDrivePackage";
import {BuyMTPLDialog} from "../../../../components/dialogs/BuyMTPLDialog";
import {ContactPhoneDialog} from "../../../../components/dialogs/ContactPhoneDialog";
import {ApplicationAcceptedDialog} from "../../../../components/dialogs/ApplicationAcceptedDialog";
import {createLead} from "../../../../api/leadApiClient";
import {VTPLSelectBlock} from "./VtplSelectBlock";
import {BaseSmartDrivePackage} from "./BaseSmartDrivePackage";
import { useHotjar } from "../../../../utils/hooks/useHotjar";

export const MtplPackageSelectFormSmartDrive = ({packages, onPackageSelect, onBackStep}) => {
    const [askPhone, setAskPhone] = useState(false);
    const [noSmartDrive, setNoSmartDrive] = useState(false);
    const [isBuyMtplDialogOpen, setBuyMtplDialogOpen] = useState(false);
    const [isAskPhoneToContactDialogOpen, setAskPhoneToContactDialogOpen] = useState(false);
    const [isApplicationAcceptedDialogOpen, setApplicationAcceptedDialogOpen] = useState(false);

    const {
        quotation,
        selectedDeductible,
        selectedPackage,
        selectedProgram,
        onDeductibleChangeListener,
        onSalesProgramOptionSelect,
        setScrollToSalesOptions,
        refSalesOptions,
        refVTPLSelectBlock,
        MTPLIsHidden,
        CASCOIsHidden,
        VTPLIsHidden,
        vtplError,
        setVtplError,
        selectedVtplSumInsured,
        selectedVtplPremium,
        setSelectedVtplPremium,
        selectedVtplCovered,
    } = useMtlPackageSelect(packages);

    const { trackHotjar} = useHotjar()

    useEffect(() => {
        trackHotjar("select", "mtpl")
    }, [])

    const nextStepHandler = () => {
        if (selectedVtplSumInsured === undefined && !(VTPLIsHidden() || !selectedVtplCovered)) {
            setVtplError(true);
        } else {
            let vtplCoveragePremium = selectedVtplPremium;

            if (selectedVtplSumInsured) {
                const vtplCoverage = selectedPackage.vtplAdditionalCoverage.find(value =>
                    value.sumInsured === selectedVtplSumInsured);

                setSelectedVtplPremium(vtplCoverage.premium);
                vtplCoveragePremium = vtplCoverage.premium;
            }

            onPackageSelect(
                selectedProgram.deductible,
                selectedProgram.cascoCovered,
                selectedProgram.totalPremium,
                selectedVtplCovered,
                selectedVtplSumInsured,
                selectedProgram.mtplPremium,
                vtplCoveragePremium,
                selectedProgram.cascoPremium
            )
        }
    }

    function getTotalPremium(): number {
        const pack = packages.filter(v => v.deductible == selectedPackage.deductible)[1]
        return pack.premium + pack.cascoAdditionalCoverage[1].premium
    }

    const getUnicFranshize = () => {
        const fran = Array.from(new Set(packages.map(value => ({value: value.deductible.toString()})).slice(0, 8)));
        return fran as SelectOption[];
    }


    return (
        <div className="package-select-form">
            <PhoneAskDialog open={askPhone}
                            onPhoneSubmit={(values) => {
                                quotation.mtplContract.raxelPhone = values.phone;
                                setAskPhone(false);
                                nextStepHandler();
                            }}
                            noSmartDriveListener={() => {
                                setAskPhone(false);
                                setNoSmartDrive(true)
                            }}/>

            <NoSmartDriveDialog open={noSmartDrive}
                                alreadyInstallListener={() => {
                                    setNoSmartDrive(false);
                                    setAskPhone(true);
                                }}
                                onCancel={() => {
                                    setNoSmartDrive(false);
                                    setBuyMtplDialogOpen(true);
                                }}
            />
            <BuyMTPLDialog open={isBuyMtplDialogOpen}
                           onCancel={() => {
                               setBuyMtplDialogOpen(false)
                               setAskPhoneToContactDialogOpen(true);
                           }}
            />
            <ContactPhoneDialog open={isAskPhoneToContactDialogOpen}
                                onPhoneSubmit={(values) => {
                                    createLead(values.phone, "MTPL Smart Drive")
                                        .then(() => setApplicationAcceptedDialogOpen(true))
                                }}
            />
            <ApplicationAcceptedDialog open={isApplicationAcceptedDialogOpen}/>

            <div className="package-select-form__container">
                <div className="package-select-form__deductible_select">
                    <div className={'package-select-form__deductible_select__label'}>
                        {strings.franchise}
                    </div>
                    <div className={'package-select-form__deductible_select__radiogroup'}>
                        <RadioGroup
                            idPrefix={'franchise'}
                            value={selectedDeductible.toString()}
                            options={getUnicFranshize()}
                            getLabel={({value}) => `${sumInsuredFormat(value)} ${strings.currencyUAH}`}
                            onChange={
                                onDeductibleChangeListener
                            }/>
                    </div>


                    <div className={"package-select-form__deductible_select__tooltip"}>
                        <SimpleTooltip id={'whatIsFranchise'} title={
                            <span><span
                                className={"accent"}>{strings.franchise2}</span>{strings.franchiseDescription}</span>}>
                            <OutputLink label={strings.whatIsFranchise} variant={"grey"}/>
                        </SimpleTooltip>
                    </div>
                </div>

                <div className="package-select-form__salesprogram">
                    <div className={'package-select-form__salesprogram__label'}>
                        {strings.chooseProgram}
                    </div>
                    <div className="package-select-form__salesprogram__options" ref={refSalesOptions}
                    >
                        {MTPLIsHidden() && (
                            <EmptySalesPackage name={strings.scenarioHeaderName}>
                                <SalesPackageOption
                                    name={strings.packageOptionEmptyText}
                                    covered={false}/>
                            </EmptySalesPackage>
                        )}

                        {!MTPLIsHidden() && (
                            <>

                                <BaseSmartDrivePackage
                                    packageName={strings.smartDrive.packageBaseName}
                                    vehicleGroup={findVehicleGroup(quotation.mtplContract.vehicle.vehicleType)}
                                    premium={selectedPackage.premium}
                                    totalPremium={packages.filter(v => v.deductible == selectedPackage.deductible)[1].premium}
                                    selected={selectedProgram && !selectedProgram.cascoCovered}
                                    onSelect={() => {
                                        onSalesProgramOptionSelect({
                                            packageName: strings.smartDrive.packageBaseName,
                                            cascoCovered: false,
                                            mtplPremium: selectedPackage.premium,
                                            cascoPremium: selectedPackage.cascoAdditionalCoverage[0].premium,
                                            deductible: selectedPackage.deductible,
                                            totalPremium: selectedPackage.premium
                                        });
                                        setScrollToSalesOptions(true);
                                    }}/>

                                {!CASCOIsHidden() && (
                                    <CascoSmartDrivePackage
                                        packageName={strings.smartDrive.packageBasePlusName}
                                        more={(
                                            <a target="_blank"
                                               rel="noopener noreferrer"
                                               href={`${process.env.PUBLIC_URL}/resources/product_conditions_direct_sales.pdf`}>{strings.smartDrive.learnMoreAboutSmartDrive}</a>
                                        )}
                                        premium={selectedPackage.premium + selectedPackage.cascoAdditionalCoverage[0].premium}
                                        vehicleGroup={findVehicleGroup(quotation.mtplContract.vehicle.vehicleType)}
                                        deductible={selectedDeductible}
                                        selected={selectedProgram?.cascoCovered}
                                        totalPremium={getTotalPremium()}
                                        onSelect={() => {
                                            onSalesProgramOptionSelect({
                                                packageName: strings.smartDrive.packageBasePlusName,
                                                cascoCovered: true,
                                                mtplPremium: selectedPackage.premium,
                                                cascoPremium: selectedPackage.cascoAdditionalCoverage[0].premium,
                                                deductible: selectedPackage.deductible,
                                                totalPremium: selectedPackage.premium + selectedPackage.cascoAdditionalCoverage[0].premium
                                            });
                                            setScrollToSalesOptions(true);
                                        }}/>
                                )}
                            </>
                        )}
                    </div>


                    <div className="package-select-form__vtpl">
                        <div
                            ref={refVTPLSelectBlock}
                            hidden={VTPLIsHidden()}>
                            <div className="package-select-form__vtpl__options">
                                <VTPLSelectBlock
                                    isSmartDrive={true}
                                    error={vtplError}
                                    onSelectListener={(sumInsured: number) => {
                                        setVtplError(false);
                                    }}
                                    vtplOptions={selectedPackage.vtplAdditionalCoverage.map((value, index) => {
                                        return {
                                            premium: value.premium,
                                            sumInsured: value.sumInsured,
                                            totalPremium: selectedPackage.vtplAdditionalCoverage.filter(v => v.sumInsured === value.sumInsured)[1].premium
                                        };
                                    }).filter((_, index) => index !== 2 && index !== 3)}/>
                            </div>
                        </div>

                        <div className="package-select-form__discount-list">
                            <div className="package-select-form__discount-list__icon">
                                <ReactSVG src={discount_icon}/>
                            </div>

                            <div className="package-select-form__discount-list__title">
                                <span>{strings.discount.title}</span>
                            </div>

                            <div className="package-select-form__discount-list__content">
                                <div className="package-select-form__discount-list__description">
                                    <span>{strings.discount.text1}</span>
                                </div>

                                <div className="package-select-form__discount-list__grid">
                                    <div className="package-select-form__discount-list__grid__row">
                                        <span>{strings.discount.text2}</span>
                                        <span>{strings.discount.text3}</span>
                                        <span>{strings.discount.text4}</span>
                                        <span>{strings.discount.text5}</span>
                                        <span>{strings.discount.text6}</span>
                                        <span>{strings.discount.text7}</span>
                                    </div>

                                    <div className="package-select-form__discount-list__grid__row">
                                        <span>{strings.discount.text8}</span>
                                        <span>{strings.discount.text9}</span>
                                        <span>{strings.discount.text10}</span>
                                        <span>{strings.discount.text11}</span>
                                        <span>{strings.discount.text12}</span>
                                        <span>{strings.discount.text13}</span>
                                    </div>
                                </div>

                                <div className="package-select-form__discount-list__description">
                                    <span>{strings.discount.text14}</span>
                                </div>

                                <div className="package-select-form__discount-list__help-text">
                                    <li>{strings.discount.text15}
                                    </li>
                                    <li>{strings.discount.text16}</li>
                                    <li>{strings.discount.text17}
                                    </li>
                                    <li>{strings.discount.text18}
                                    </li>
                                </div>

                                <div className="package-select-form__discount-list__description">
                                    <span>{strings.discount.text19}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <StepControls nextIsAvailable={selectedProgram !== undefined}
                          onNext={() => {
                              if (selectedVtplSumInsured === undefined && !VTPLIsHidden()) {
                                  setVtplError(true);
                                  return;
                              }
                              setNoSmartDrive(true);
                          }}
                          onBack={onBackStep}
                          leftSteps={2}/>
        </div>
    );
}
